import { createContext } from 'react';

import type { RectSeriesIdToValueScaleDomain } from '../types/xy-chart-internals.js';

export interface RectDataContext {
  seriesIdToValueScaleDomain?: RectSeriesIdToValueScaleDomain;
}

export const XYChartRectDataContext = createContext<
  RectDataContext | undefined
>(undefined);

XYChartRectDataContext['displayName'] = 'XYChartRectDataContext';
